import { render, staticRenderFns } from "./mc-meal-wizard.tests.vue?vue&type=template&id=5d5cb996&scoped=true"
import script from "./mc-meal-wizard.tests.vue?vue&type=script&lang=ts"
export * from "./mc-meal-wizard.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5cb996",
  null
  
)

export default component.exports